module.exports = __webpack_public_path__ + "static/img/twjd-sdb4.38b9af9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdb4.png
// module id = 831
// module chunks = 0